module.exports = __webpack_public_path__ + "static/media/overview-600x400.8b2fc74c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/home/assets/overview-600x400.jpg
// module id = 1082
// module chunks = 1